var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.47529 3.25312C4.81278 2.91563 5.35996 2.91563 5.69746 3.25312L12 9.55566L18.3025 3.25312C18.64 2.91563 19.1872 2.91563 19.5247 3.25312L20.7469 4.47529C21.0844 4.81278 21.0844 5.35996 20.7469 5.69746L14.4443 12L20.7469 18.3025C21.0844 18.64 21.0844 19.1872 20.7469 19.5247L19.5247 20.7469C19.1872 21.0844 18.64 21.0844 18.3025 20.7469L12 14.4443L5.69746 20.7469C5.35996 21.0844 4.81278 21.0844 4.47529 20.7469L3.25312 19.5247C2.91563 19.1872 2.91563 18.64 3.25312 18.3025L9.55566 12L3.25312 5.69746C2.91563 5.35996 2.91563 4.81278 3.25312 4.47529L4.47529 3.25312Z","fill":"white"}));
}

Close.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Close;

Close.default = Close;
